import ProfileImage from 'assets/images/silhouette.jpg';
import {DirectBookingProviderType} from 'interfaces';

export type TProfessionalHeadshot = {
  small: string;
  medium: string;
  large: string;
  full: string;
};

export const mapProviderData = (p?: DirectBookingProviderType) => ({
  userId: p?.userId ?? '',
  providerId: p?.providerId ?? '',
  calendarId: p?.calendarId,
  fullName: p?.providerFullName ?? '',
  bio: p?.introductoryBio ?? '',
  licences: p?.titleProviderPerformingSpecialtyProviderLicenseType ?? [],
  states: p?.state ?? [],
  acceptedInsurances: p?.acceptedInsurance ?? [],
  conditions: p?.conditions ?? [],
  education: p?.educationAndProfessionalTraining ?? '',
  ethnicity: p?.ethnicity ?? [],
  languages: p?.languages ?? [],
  headshot: {
    small: p?.professionalHeadshot?.[0].thumbnails?.small?.url ?? ProfileImage,
    medium: p?.professionalHeadshot?.[0].thumbnails?.large?.url ?? ProfileImage,
    large: p?.professionalHeadshot?.[0].url ?? ProfileImage,
    full: p?.professionalHeadshot?.[0].thumbnails?.small?.url ?? ProfileImage,
  },
});
